import OptionHOC, { getOptionLabel } from '@platform/react/hoc/autocomplete/option'
import { Grid } from '@mui/material'
import Text from 'ui/Element/Text'
import Icon from 'ui/Element/Icon'
import { getSubLabel } from 'lib/util/string'

const styles = () => ({
  option: {
    gap: 12,
    flexWrap: 'nowrap',
  },
  subLabel: {
    gap: 4,
  },
  icon: {
    width: '3rem',
    height: '3rem',
  },
})

/**
 * Displays the name of a person alongside their email as a sub label.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {*}
 */
const PersonOption = (classes, props = {}) => {
  const { option, labels } = props
  const { email: emailLabel } = labels
  const { value: { contactChannels = [] } } = option || {}

  const email = contactChannels.find(channel => channel.type === 'email')?.value
  const subLabel = getSubLabel(Text, [emailLabel, email])

  return (
    <Grid
      container
      direction={'row'}
      className={classes.option}
    >
      <Grid
        item
        ms={'auto'}
        className={classes.icon}
      >
        <Icon
          size={24}
          rounded={true}
          source={'user'}
          padding={'0.5rem'}
          background={'gray.960'}
        />
      </Grid>
      <Grid
        item
        ms={'auto'}
      >
        <Grid
          container
          height={'100%'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}
        >
          <Text
            maxLines={1}
            value={getOptionLabel(option)}
            variant={'14/bold'}
            color={'black.main'}
          />
          {emailLabel && email && (
            <Grid
              item
              container
              ms={'auto'}
              className={classes.subLabel}
            >
              {subLabel}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default OptionHOC(PersonOption, styles)
